import { __ } from '@wordpress/i18n';
const dropicons = [
    {
        label: __('Plus Minus','spice-blocks'),
        value: 'fa-solid fa-plus_fa-solid fa-minus'
    },
    {
        label: __('Arrow Up Down','spice-blocks'),
        value: 'fas fa-chevron-down_fas fa-chevron-up'
    },
    {
        label: __('Arrow Up Down Alt','spice-blocks'),
        value: 'fas fa-sort-down_fas fa-sort-up'
    },
    {
        label: __('Hands Up Down','spice-blocks'),
        value: 'fas fa-hand-point-down_fas fa-hand-point-up'
    },
    {
        label: __('Arrow Up Down With Circle','spice-blocks'),
        value: 'fas fa-chevron-circle-down_fas fa-chevron-circle-up'
    }
];

export default dropicons;